module.exports = __webpack_public_path__ + "img/西安理工.493c8c4b.png";